export default __webpack_public_path__ + "static/media/bad-gateway-502.efa9a4dd.png";